import { render, staticRenderFns } from "./CodeStatisticsListView.vue?vue&type=template&id=6b53d6c2&scoped=true"
import script from "./CodeStatisticsListView.vue?vue&type=script&lang=js"
export * from "./CodeStatisticsListView.vue?vue&type=script&lang=js"
import style0 from "./CodeStatisticsListView.vue?vue&type=style&index=0&id=6b53d6c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b53d6c2",
  null
  
)

export default component.exports